<template>
    <div class="container-fluid">
        <CRow class="pr-2">
    <CCol col="12" xl="12" class="p-0">
      <CCard>
        <CCardBody>

   <a-card class="edit-card" style="margin:0;" :body-style="{padding:0}">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted">Nastavenia > <router-link to="/blocks">Bloky</router-link></h6>
                            Bloky</span>
                            <span slot="extra">
         <router-link to="/block/add"> <a-button type="primary">Pridať blok</a-button></router-link>
                           </span>



                        <div class="table-responsive">
                            <a-table
                                    :columns="columns"
                                    :row-selection="rowSelection"
                                    :rowKey="record => record.id"
                                    :dataSource="data"
                                     :pagination="pagination"
                                    :loading="loading"
                                    class="table-flush">
                                <template slot="contenttype" slot-scope="ct,record">
                                    <span v-if="ct">{{fetchcttitle(ct)}}</span>
                                    <span v-else><template v-if="record.vocabulary">-</template><template v-else>Všetky typy obsahov</template></span>
                                </template>
                                <template slot="vocabulary" slot-scope="ct">
                                    <span v-if="ct">{{fetchvoctitle(ct)}}</span>
                                    <span v-else>-</span>
                                </template>
<template slot="pages" slot-scope="pagesValue">
  <div v-if="parsePages(pagesValue).length">
    <div v-for="p in parsePages(pagesValue)" :key="p.id">
      <router-link :to="`/edit-content/${p.id}`">
        {{ p.title }}
      </router-link>
    </div>
  </div>
  <span v-else>-</span>
</template>

                                <template slot="section" slot-scope="sectionValue">
                                    <span v-if="sectionValue && sectionLabels[sectionValue]">{{ sectionLabels[sectionValue] }}</span>
                                    <span v-else-if="sectionValue">{{ sectionValue }}</span>
                                    <span v-else>-</span>
                                </template>

                                <template slot="name" slot-scope="user">
                                <span class="actions">
                                    <router-link :to="'/block/' + user.id">
                                        <a-button class="mr-1">Upraviť</a-button>
                                    </router-link>
                                    <a-popconfirm placement="topRight"
                                                  @confirm="confirm(user.id)"
                                                  @cancel="cancel"
                                                  okText="Áno"
                                                  cancelText="Nie">
                                        <template slot="title">
                                            <h5 color="danger">Prajete si tento obsah vymazať?</h5>
                                            Položka bude trvalo odstránená z vašej stránky.
                                        </template>
                                        <a-button type="danger">Zmazať</a-button>
                                    </a-popconfirm>
                                </span>
                                </template>
                            </a-table>
                        </div>
                          <div  style="bottom:0" class="action-panel w-25 m-3 float-left"  v-if="rowSelection.selectedRowKeys.length > 0">
                                <a-select style="width:150px;"  class="mr-3" size="small" placeholder="Vyberte si akciu" v-model="action" :options="actions"></a-select>
                                <a-popconfirm placement="topRight"
                                              @confirm="doAction"
                                              @cancel="cancel"
                                              okText="Áno"
                                              cancelText="Nie"
                                >
                                    <template slot="title">
                                        <h5 color="danger" >Prajete si vykonať tento príkaz?</h5>
                                        Príkaz sa vykoná pre {{rowSelection.selectedRowKeys.length}} <span v-if="rowSelection.selectedRowKeys.length === 1">blok</span> <span v-if="rowSelection.selectedRowKeys.length > 1 && rowSelection.selectedRowKeys.length < 5">bloky</span> <span v-if="rowSelection.selectedRowKeys.length > 4">blokov</span>.
                                    </template>
                                   <a-button type="warning">Vykonať</a-button>
                                </a-popconfirm>
                            </div>
                            </a-card>
                            </CCardBody>
                            </CCard>
                            </CCol>
                            </CRow>

                    </div>

</template>
<script>
    import {dataService} from "../_services";
    import {Popconfirm, Select} from "ant-design-vue"


    export default {
        name: "blocks",
        props: ["id"],
        components: {
            "a-popconfirm": Popconfirm,
            "a-select": Select
        },
        data() {
            return {
                data: [],
                ctt: [],
                colorsto: JSON.parse(localStorage.colors),
                loading: false,
                sectionLabels: {
                    '0': 'Nepriradené',
                    '1': 'Hlavička',
                    '2': 'Banner',
                    '3': 'Hlavná sekcia',
                    '4': 'Ľavá časť',
                    '5': 'Pravá časť',
                    '6': 'Päta',
                    '7': 'Top stránky',
                    '8': 'Upozornenia',
                    '9': 'Sidebar',
                },
                languages: null,
                vocabularies: [],
                basicpages:[],
                 basicpages: [],
    pageTitleById: {}, // NEW
                filteredInfo: null,
                actions: [{"value" : 'delete' , "label" : 'Zmazať'}],
                action:undefined,
                pagination: {
                    hideOnSinglePage: true,
                    pageSize: 100, // default number of pages per page
                    showSizeChanger: true, // display can change the number of pages per page
                    pageSizeOptions: ['10', '20', '30', '40', '100'], // number of pages per option
                    showTotal: total => `Položiek: ${total}`, // show total
                    showSizeChange: (current, pageSize) => {  this.pageSize = pageSize; }, // update display when changing the number of pages per page
                },
                sortedInfo: null,
                selectedRowKeys: [],
            };
        },
        computed: {
            columns() {
                // eslint-disable-next-line no-unused-vars
                let { sortedInfo, filteredInfo } = this;
                sortedInfo = sortedInfo || {};
                filteredInfo = filteredInfo || {};
                const columns = [
                    {
                        title: 'Popis bloku',
                        dataIndex: 'des',
                        sorter: true,
                        width: '20%',
                    },
                   {
                        title: 'Jazyk',
                        scopedSlots: {customRender: 'language'},
                        filters: this.languages,
                        onFilter: (value, record) => record.language.includes(value),
                        dataIndex: 'language',
                    },
                    {
                        title: 'Typ obsahu',
                        scopedSlots: {customRender: 'contenttype'},
                        filters: this.ctt,
                        onFilter: (value, record) => record.content_type.includes(value),
                        dataIndex: 'showon',
                    },
                    {
                      title: 'Stránka',
                      dataIndex: 'pages',
                      scopedSlots: { customRender: 'pages' },
                    },
                    {
                      title: 'Sekcia',
                      dataIndex: 'section',
                      scopedSlots: { customRender: 'section' },
                      width: '120px',
                    },
                    {
                        title: 'Slovník',
                        scopedSlots: {customRender: 'vocabulary'},
                        filters: this.ctt,
                        onFilter: (value, record) => record.content_type.includes(value),
                        dataIndex: 'vocabulary',
                    },

                    {
                        align: 'right',
                        scopedSlots: {customRender: 'name'},
                    }
                ];
                return columns;     },
                          rowSelection() {
                const { selectedRowKeys } = this;
                return {
                    selectedRowKeys,
                    onChange: this.onSelectChange,
                    hideDefaultSelections: true,
                    onSelection: this.onSelection,
                };
            },
        },
        mounted() {
            this.fetch();
        },
        methods: {
              onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            confirm(e) {
                dataService.axiosDelete(this.$options.name, e).then(results => {
                    if (results) {
                        this.data.splice(this.data.findIndex(x => parseInt(x.id) === parseInt(e)), 1);
                    }
                });
            },
            cancel() {
            },
               doAction()
                {
                    if(this.action)
                    {
                    dataService.axiosPost('blockaction/' + this.action, { 'blocks' : this.rowSelection.selectedRowKeys}).then(() => {
                        this.rowSelection.selectedRowKeys = [];
                        this.selectedRowKeys = [];
                        this.fetch();
                        this.action = undefined;

                    });
                   }
                },
            handleChange(pagination, filters, sorter) {
                this.filteredInfo = filters;
                this.sortedInfo = sorter;
            },
            clearFilters() {
                this.filteredInfo = null;
            },
            fetchcttitle(ct)
            {
                let tcc = this.contenttypes.find(x => x.slug === ct);
                return tcc.title;
            },
            fetchvoctitle(ct)
            {
                let tcc = this.vocabularies.find(x => x.slug === ct);
                return tcc.title;
            },
           fetchtitle(id) {
  if (!id && id !== 0) return '';
  const key = String(id);
  return this.pageTitleById[key] || key;
},
parsePages(pagesValue) {
  if (!pagesValue) return [];

  // normalize to one string
  let raw = '';
  if (Array.isArray(pagesValue)) raw = pagesValue.join(' ');
  else raw = String(pagesValue);

  // split by whitespace/comma/semicolon/newlines
  const tokens = raw
    .split(/[\s,;]+/g)
    .map(s => s.trim())
    .filter(Boolean);

  const out = [];
  const seen = new Set();

  tokens.forEach(t => {
    // expects "node/3556" but will also accept any ".../3556"
    const m = t.match(/\/(\d+)\s*$/) || t.match(/^(\d+)$/);
    if (!m) return;

    const id = m[1];
    if (seen.has(id)) return;
    seen.add(id);

    out.push({
      id,
      title: this.fetchtitle(id) || `ID ${id}`,
    });
  });

  return out;
},
            fetch() {
                this.loading = true;

                dataService.axiosFetch("contenttypes").then(results => {
                    this.contenttypes = results;

                    results.forEach(obj => {
                        var iid = obj.id;
                        var vval = obj.title;
                        this.ctt.push({"text" : vval,"value" : iid});

                    });
                });

 dataService.axiosFetch("listof/page").then(results => {
  this.basicpages = results || [];
  const map = {};
  this.basicpages.forEach(p => {
    map[String(p.value)] = p.label;
  });
  this.pageTitleById = map;
});




 dataService.axiosFetch("taxonomies").then(results => {
                    this.vocabularies = results;

                    results.forEach(obj => {
                        var iid = obj.id;
                        var vval = obj.title;
                        this.vocabularies.push({"text" : vval,"value" : iid});

                    });
                });


                   dataService.axiosFetch("languages").then(results => {
                var roleops = [];
              var actions = [];
              actions.push({"value" : 'delete' , "label" : 'Zmazať'});
                results.forEach(obj => {
                     roleops.push({"value" : obj.short , "text" : obj.title});
                     actions.push({"value" : obj.short , "label" : 'Vytvoriť ' + obj.short + ' preklad'});
                     });
                this.languages = roleops;
                this.actions = actions;
            });

                dataService.axiosFetch(this.$options.name,this.id).then(results => {
                    this.data = results;
                    this.loading = false;
                    //this.data.sort((a,b) => (parseInt(a.id) > parseInt(b.id)) ? 1 : ((parseInt(b.id) > parseInt(a.id)) ? -1 : 0));


                  //  this.data.sort((a, b) => parseInt(a.id).localeCompare(parseInt(b.id), undefined, { numeric: true, sensitivity: 'base' }));
                    this.data.sort(function(a, b){
                        return parseInt(a.id)-parseInt(b.id)
                    })
this.data = this.data.reverse();
                });
            }

        },
    };
</script>

<style>
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }

    .ant-table-pagination.ant-pagination {
        margin-bottom: 40px;
        margin-right: 20px;
    }

    .ant-pagination5-item {
        border: 0;
    }

    .ant-table {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a, .ant-pagination5-jump-prev a, .ant-pagination5-jump-next a {
        -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        border: 0;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0;
        margin: 0 3px;
        border-radius: 50% !important;
        width: 36px;
        height: 36px;
        font-size: 0.875rem;
    }


    .ant-pagination5-item.ant-pagination5-item-active a {
        z-index: 1;
        color: #fff;
        background-color: #5e72e4;
        border-color: #5e72e4;
    }

    .ant-pagination5-item-link.ant-pagination5-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

</style>
